module.exports = __webpack_public_path__ + "img/ed097d0ed091cfd2d7c956a84424fc8b.png";